import React, { useEffect, useState } from "react";
import Modal from "../../Components/Modal/Modal";
import { getProductDetailApi } from "../../Api/BarestSupplierServices";
import LoadingComponet from "../../Components/LoadingComponet/LoadingComponet";
import MenuProduct from "../../Components/MenuProduct/MenuProduct";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import ProductItem from "../../Components/ProductItem/ProductItem";
import SearchBar from "../../Components/SearchBar/SearchBar";
import Style from "./AddingProduct.module.css";

const AddingProduct = () => {
  const [availables, setAvailable] = useState();
  const [index, setIndex] = useState();
  const [click, setClick] = useState();
  const [search, setSearch] = useState("");
  const [searchProduct, setsearchProduct] = useState("");
  const [openModal, setOpenModal] = useState(false);

  /////دیتا برای ایتم های منو
  const data = [
    {
      id: "0",
      category: "ناموجود",
    },
    {
      id: "1",
      category: "موجود",
    },
    {
      id: "2",
      category: "همه",
    },
  ];
  useEffect(() => {
    list(2);
  }, []);

  //////////کلیک کردن روی آیتم های منو
  const categoryHandle = (id) => {
    let avail = null;
    //همه
    if (id === "2") {
      avail = "2";
    }
    //ناموجود
    else if (id === "0") {
      avail = "0";
    }
    //موجود
    else if (id === "1") {
      avail = "1";
    }
    list(avail);
    setClick(true);
    setIndex(id);
  };

  const list = (id) => {
    const info = {
      exist: id,
      category_id: 0,
    };
    getProductDetailApi(info, (suc) => {
      if (suc) {
        setAvailable(suc.products.reverse());
      } else {
        <LoadingComponet />;
      }
    });
  };
  const openModalHandle = () => {
    setOpenModal(true);
  };
  const closeModalHandle = () => {
    setOpenModal(false);
  };
  return (
    <div className={Style.pageHolder}>
      <Modal show={openModal} modalClose={closeModalHandle} translate={40}>
        <input
          onChange={setsearchProduct}
          value={searchProduct}
          className={Style.selectProduct}
          placeholder={"جستجو محصول"}
        />
      </Modal>
      <MenuTitle title={"افزودن محصول"} />
      <div className={Style.centerHolder}>
        <MenuProduct
          openModalHandle={openModalHandle}
          addProduct={true}
          click={click}
          categoryHandle={categoryHandle}
          index={index}
          setIndex={setIndex}
          data={data}
        />
        <SearchBar search={search} setSearch={setSearch} />
        {availables && (
          <ProductItem
            search={search}
            getProductDetail={list}
            availables={availables}
            index={index}
            setAvailable={setAvailable}
          />
        )}
      </div>
    </div>
  );
};

export default AddingProduct;
